import React, {useState } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import moment from 'moment';

import Loading from "../components/Loading";
import Navigation from "../components/Navigation";
import BrandBar from "../components/BrandBar";

// Charts
import CompetitionTable from '../components/widgets/CompetitionTable';
import CompetitionTable2 from '../components/widgets/CompetitionTable2';
import WallOfFame from '../components/widgets/WallOfFame';

export const Competition = (props) => {

	//STATE
	const [filterData, setFilterData] = useState({
		active_start_date: new Date('2026-06-25'),
		active_end_date: new Date('2026-09-03'),
		// active_start_date: new Date('2025-09-24'),
		// active_end_date: new Date('2025-09-28'),
	});

	return (
		<div className="app-container">
			<div className="app-sidebar">
				<BrandBar/>
				<Navigation page_title="Dashboard"/>
			</div>
			
			<div className="app-content">
				<div className="page-content">

					<div className="page-content-inner">
						<div className="page-content-inner-centering--wide">

							<div className="page-content-header">
								
								<div className="page-content-header-titel-block">
									<h1 className="page-title">Konkurrence</h1>

									<div className="page-description">
										<p>
											{moment(filterData.active_start_date).format('DD/MM/YYYY')} — {moment(filterData.active_end_date).format('DD/MM/YYYY')}
										</p>
									</div>
								</div>

							</div>
						
							<div className="page-charts">

								<CompetitionTable
									start_date={filterData.active_start_date}
									end_date={filterData.active_end_date}
									departments={props.globalData.departments}
								/>

								{/*
								<CompetitionTable2
									start_date={filterData.active_start_date}
									end_date={filterData.active_end_date}
								/>
								*/}

								<WallOfFame/>
								
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	); 
};

export default withAuthenticationRequired(Competition, {
  onRedirecting: () => <Loading />,
});
